import React from 'react';
import { CTAButton } from './CTAButton';
export const HeroSection: React.FC = () => {
  return <section className="bg-gradient-to-br from-green-dark via-green-mid to-brown-dark text-white text-center pt-[50px] px-5 pb-[30px] relative overflow-hidden" data-id="element-122">
      <div className="text-[11px] font-sans font-bold tracking-[3px] text-[#A5D6A7] uppercase mb-1.5" data-id="element-123">
        🌿 TIERRA VIVA™
      </div>
      <h1 className="text-[clamp(24px,4.5vw,46px)] leading-[1.08] font-black mb-2 max-w-[750px] mx-auto" data-id="element-124">
        Todo lo que necesitás para
        <br data-id="element-125" />
        construir tu casa de barro.
        <br data-id="element-126" />
        <em className="text-gold-main not-italic" data-id="element-127">Listo. Desde hoy.</em>
      </h1>

      <div className="flex justify-center mb-3 w-full max-w-sm mx-auto" data-id="element-128">
        <img src="https://cdn.magicpatterns.com/uploads/eVh5m7RKDUPcvcCpXhfET2/eb3fb1ef-73ad-4646-86eb-9620a5d20949.png" alt="Mega Pack Tierra Viva" className="w-full max-w-[260px] h-auto object-contain drop-shadow-2xl" data-id="element-129" />
      </div>

      <p className="text-[clamp(14px,2.2vw,19px)] font-sans font-bold text-[#C8E6C9] mb-1" data-id="element-130">
        MEGA PACK TIERRA VIVA — Trilogía Completa + 4 Bonos Pro
      </p>
      <p className="text-[clamp(13px,1.8vw,16px)] text-[#A5D6A7] max-w-[600px] mx-auto mb-4 font-sans leading-[1.5]" data-id="element-131">
        El sistema N°1 de bioconstrucción para el autoconstructor moderno — Del
        suelo al techo — Sin experiencia previa necesaria
      </p>

      <div className="flex justify-center flex-wrap gap-1.5 mb-4 max-w-[500px] mx-auto" data-id="element-132">
        {['📄 100% PDF', '⚡ 5 min', '🏗️ 3 Tomos', '📐 150 Págs', '🌿 2026'].map((pill, i) => <span key={i} className="bg-white/10 border border-white/20 text-white py-1 px-2.5 rounded-full text-[10px] font-sans font-semibold" data-id="element-133">
            {pill}
          </span>)}
      </div>

      <CTAButton href="#comprar" data-id="element-134">🌿 → QUIERO MI MEGA PACK AHORA</CTAButton>

      <p className="text-[12px] text-[#A5D6A7] mt-2 font-sans" data-id="element-135">
        🛡️ Garantía 7 días &nbsp;|&nbsp; 🔒 Pago seguro &nbsp;|&nbsp; 💳 Mercado
        Pago
      </p>

      <div className="flex justify-center flex-wrap gap-[25px] mt-[30px] pt-[25px] border-t border-white/10" data-id="element-136">
        <div className="text-center" data-id="element-137">
          <span className="block text-[26px] font-black text-gold-main leading-none" data-id="element-138">
            +300
          </span>
          <span className="text-[10px] text-[#A5D6A7] font-sans uppercase tracking-[1px] mt-1 block" data-id="element-139">
            autoconstructores
          </span>
        </div>
        <div className="text-center" data-id="element-140">
          <span className="block text-[26px] font-black text-gold-main leading-none" data-id="element-141">
            3
          </span>
          <span className="text-[10px] text-[#A5D6A7] font-sans uppercase tracking-[1px] mt-1 block" data-id="element-142">
            tomos completos
          </span>
        </div>
        <div className="text-center" data-id="element-143">
          <span className="block text-[26px] font-black text-gold-main leading-none" data-id="element-144">
            4
          </span>
          <span className="text-[10px] text-[#A5D6A7] font-sans uppercase tracking-[1px] mt-1 block" data-id="element-145">
            bonos incluidos
          </span>
        </div>
        <div className="text-center" data-id="element-146">
          <span className="block text-[26px] font-black text-gold-main leading-none" data-id="element-147">
            4.9/5
          </span>
          <span className="text-[10px] text-[#A5D6A7] font-sans uppercase tracking-[1px] mt-1 block" data-id="element-148">
            calificación ⭐
          </span>
        </div>
      </div>
    </section>;
};